// *******************
// *******************
// FILE AUTO GENERATO! n// *******************
// *******************

export const _mascheraDispositivoData = {
  "GFL_TFL_700": {
    "Maschera": "GFL_TFL_700",
    "RegistroAlertBindings": []
  },
  "GFL_MONITORING_WTP": {
    "Maschera": "GFL_MONITORING_WTP",
    "RegistroAlertBindings": [
      {
        "ProprietaMisurataType": "umidita",
        "AlertType": "soglia1",
        "SogliaCheckType": "moreThan",
        "Registro": "measHumTh1"
      },
      {
        "ProprietaMisurataType": "umidita",
        "AlertType": "soglia2",
        "SogliaCheckType": "moreThan",
        "Registro": "measHumTh2"
      },
      {
        "ProprietaMisurataType": "particelle_iso4",
        "AlertType": "soglia1",
        "SogliaCheckType": "moreThan",
        "Registro": "measPartTh1"
      },
      {
        "ProprietaMisurataType": "particelle_iso4",
        "AlertType": "soglia2",
        "SogliaCheckType": "moreThan",
        "Registro": "measPartTh2"
      }
    ]
  },
  "GFL_MONITORING_WT": {
    "Maschera": "GFL_MONITORING_WT",
    "RegistroAlertBindings": [
      {
        "ProprietaMisurataType": "umidita",
        "AlertType": "soglia1",
        "SogliaCheckType": "moreThan",
        "Registro": "measHumTh1"
      },
      {
        "ProprietaMisurataType": "umidita",
        "AlertType": "soglia2",
        "SogliaCheckType": "moreThan",
        "Registro": "measHumTh2"
      }
    ]
  },
  "GFL_SENSOR_WT": {
    "Maschera": "GFL_SENSOR_WT",
    "RegistroAlertBindings": [
      {
        "ProprietaMisurataType": "umidita",
        "AlertType": "soglia1",
        "SogliaCheckType": "moreThan",
        "Registro": "measHumTh1"
      },
      {
        "ProprietaMisurataType": "umidita",
        "AlertType": "soglia2",
        "SogliaCheckType": "moreThan",
        "Registro": "measHumTh2"
      }
    ]
  }
} as const